import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { LanguagePage } from './pages/LanguagePage';
interface AppProps {
  defaultLanguage?: 'et' | 'ru' | 'en';
}
export function App({
  defaultLanguage = 'et'
}: AppProps) {
  return <BrowserRouter data-id="element-0" data-mp="3k78dfenfrovf">
      <Routes data-id="element-1" data-mp="3fargpw26826q">
        <Route path="/:lang" element={<LanguagePage fallback={defaultLanguage} data-id="element-3" data-mp="3fb14re3nnz9s" />} data-id="element-2" data-mp="3fa89pae26y7h" />
        <Route path="*" element={<Navigate to={`/${defaultLanguage}`} replace data-id="element-5" data-mp="2rlypgcwhuiig" />} data-id="element-4" data-mp="2rkdwgrptv7mp" />
      </Routes>
    </BrowserRouter>;
}